import type { RemoteModulesInfo } from 'admin-web-utils'

export const fetchRemoteModulesManifest = async (
  projectName: string | undefined,
): Promise<RemoteModulesInfo> => {
  const defaultResponse = {}

  if (!projectName) {
    return defaultResponse
  }

  const response = await fetch(`/remotes/${projectName}/remote-modules.json`)

  try {
    return await response.json()
  } catch (error) {
    console.info(
      'Request for `remote-modules.json` failed. Using default response.',
      error,
    )

    return defaultResponse
  }
}
